import { Box } from "@mui/material";
import ListCreateTab from "components/ListCreateTab";
import FactoryIcon from "@mui/icons-material/FactoryOutlined";
import React from "react";
import { MdAddBox } from "react-icons/md";
import AdminStockList from "./AdminStockList";
import CommonStockInward from "../CommonStockInward";
import { useSelector } from "react-redux";

const AdminStockManagement = () => {
  const inventorySettings = useSelector(
    (state) => state.inventorySettings.data
  );
  const roles = useSelector((state) => state.auth.user.roles);
  return (
    <>
      {roles.any(["admin"]) && inventorySettings.stock_level === "admin" ? (
        <Box sx={{ display: "flex", flex: 1 }}>
          <ListCreateTab
            mod="Admin stock"
            viewIcon={<FactoryIcon />}
            createIcon={<MdAddBox />}
            createChildren={<CommonStockInward mode="admin" />}
            listChildren={<AdminStockList />}
          />
        </Box>
      ) : (
        <AdminStockList />
      )}
    </>
  );
};

export default AdminStockManagement;
